import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';
import { IDataType } from '../types/misc';

const initialState: {
  communications: IDataType[];
  update: boolean;
  loading: boolean;
} = {
  communications: [],
  update: false,
  loading: false
};

export const communication = createSlice({
  name: 'communication',
  initialState,
  reducers: {
    setCommunications: (state, action: PayloadAction<IDataType[]>) => {
      state.communications = action.payload;
    },
    createCommunication: (state, action: PayloadAction<IDataType>) => {
      state.communications = [action.payload, ...state.communications];
    },
    updateCommunication: (state, action: PayloadAction<IDataType>) => {
      state.communications = state.communications.map((item) => {
        if (item.id === action.payload.id) return action.payload;
        return item;
      });
    },
    setLoading: (state) => {
      state.loading = !state.loading;
    },
    setUpdate: (state) => {
      state.update = !state.update;
    }
  }
});

export const {
  setCommunications,
  createCommunication,
  updateCommunication,
  setLoading,
  setUpdate
} = communication.actions;

export default communication.reducer;
